/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import { isPhone } from '@helpers';
import { getBoxShadowStyle } from '@styles/shadow';

export default ({ C }) => {
  const ld = (l, d) => (C.scheme === 'light' ? l : d);
  return (
    <View
      style={{
        flexDirection: isPhone ? 'column' : 'row',
        marginTop: isPhone ? 160 : 130,
        width: '100%',
        height: '100%',
      }}
    >
      <ScrollView
        style={[
          {
            flex: 1,
          },
        ]}
      >
        <View style={{ width: '100%', paddingBottom: 100, height: 1250, alignItems: 'center', backgroundColor: ld('', '#2C2A28') }}>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Field [mobile]</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Field', C }),
              {
                backgroundColor: C(ld('Shadow/Light/Field [mobile]', 'Background/Dark/Field [mobile]')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Field [web]</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Field', C }),
              {
                backgroundColor: C(ld('Background/Light/System ', 'Background/Dark/Field [mobile]')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Narrow</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Narrow', C }),
              {
                backgroundColor: C(ld('Background/Light/System', 'Background/Dark/System')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Wide</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Wide', C }),
              {
                backgroundColor: C(ld('Background/Light/System', 'Background/Dark/System')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Symmetric</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Symmetric', C }),
              {
                backgroundColor: C(ld('Background/Light/System', 'Background/Dark/System')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
          <Text style={{ marginTop: 30, color: C('Label/Light/Primary') }}>Key</Text>
          <View
            style={[
              getBoxShadowStyle({ type: 'Key', C }),
              {
                backgroundColor: C(ld('Background/Light/System', 'Background/Dark/Field lighter')),
                width: 128,
                height: 128,
                borderRadius: 16,
              },
            ]}
          ></View>
        </View>
      </ScrollView>
    </View>
  );
};
